
var PodGridCtrl = function ($scope,$http,ajaxCall, xmsNotificationFactory, podService) {

    var _this = this;

    $scope.pods = podService.pods;
    $scope.podsProcessing = false;
    $scope.podPositionCopies = [];

    $scope.gridsterOpts = {
        columns: 4, // the width of the grid, in columns
        pushing: false, // whether to push other items out of the way on move or resize
        floating: false, // whether to automatically float items up so they stack (you can temporarily disable if you are adding unsorted items with ng-repeat)
        swapping: false, // whether or not to have items of the same size switch places instead of pushing down if they are the same size
        swappingOnDrop: true, // whether or not to have items switch places ON DROP instead of push down if they are the same size
        autoLayout: false,
        width: 'auto', // can be an integer or 'auto'. 'auto' scales gridster to be the full width of its containing element

        colWidth: 'auto', // can be an integer or 'auto'.  'auto' uses the pixel width of the element divided by 'columns'
        rowHeight: '188', // can be an integer or 'match'.  Match uses the colWidth, giving you square widgets.
        margins: [10, 10], // the pixel distance between each widget
        outerMargin: true, // whether margins apply to outer edges of the grid
        sparse: false, // "true" can increase performance of dragging and resizing for big grid (e.g. 20x50)
        isMobile: false, // stacks the grid items if true
        mobileBreakPoint: 600, // if the screen is not wider that this, remove the grid layout and stack the items
        mobileModeEnabled: true, // whether or not to toggle mobile mode when screen width is less than mobileBreakPoint
        minColumns: 4, // the minimum columns the grid must have
        minRows: 2, // the minimum height of the grid, in rows
        maxRows: 100,
        defaultSizeX: 2, // the default width of a gridster item, if not specifed
        defaultSizeY: 1, // the default height of a gridster item, if not specified
        minSizeX: 1, // minimum column width of an item
        maxSizeX: 4, // maximum column width of an item
        minSizeY: 1, // minumum row height of an item
        maxSizeY: 4, // maximum row height of an item
        resizable: {
            enabled: true,
            handles: [ 'se' ],

            start: function(event, $element, widget, item) {

                // store orignal sizeX/Y for comparision for changes in saving
                item.originalSizeX = item.sizeX;
                item.originalSizeY = item.sizeY;

                // make a copy of the items to restore them later if an operation is not allowed
                angular.copy($scope.pods,$scope.podPositionCopies)
            },
            resize: function(event, $element, widget, item) {
                // check if the new position is valid
                var valid = $scope.isValidLocation(item.row,item.col, item.sizeX, item.sizeY, widget);
                return valid;
            },
            stop: function(event, $element, widget, item) {
                if(item.validLocation) {
                    //TODO: Setting the widget should not be needed, it has the correct size when
                    //enlarging but the incorrect size when shrinking. The item however has the right sizeX
                    widget.sizeX = item.sizeX
                    widget.sizeY = item.sizeY

                    $scope.savePositions();
                }
            }
        },
        draggable: {
            enabled: true, // whether dragging items is supported
            start: function(event, $element, widget) {
                // make a copy of the items to restore them later if an operation is not allowed
                // TODO: This should not longer be needed?
                angular.copy($scope.pods,$scope.podPositionCopies)
            },
            drag: function(event,$element,widget, item, row, col) {
                // check if the new position is valid
                var valid = $scope.isValidLocation(row,col, item.sizeX, item.sizeY, widget);
                return valid;
            },
            stop: function(event, $element, widget, item, row, col) {
                if(item.validLocation) {
                    $scope.savePositions();
                }
            }
        }
    };

    $scope.isValidLocation = function (row, col, sizeX, sizeY, pod, debug) {

        var valid = true;

        if ($scope.podsProcessing) {
            console.log("pods being updated");
            return false;
        }

        if(pod.locked && (pod.xmsType != $scope.formModel.hiddenUserType)) {
            console.log("pod locked");
            return false;
        }

        for (var i = 0; i < $scope.pods.length; i++) {
            var value = $scope.pods[i];
            if ( pod.id !== value.id) {

                var podA = { left: col, right: col + sizeX - 1, top: row, bottom: row + sizeY - 1 }
                var podB = { left: value.col, right: value.col + value.sizeX - 1, top: value.row, bottom: value.row + value.sizeY - 1 }



                if(podService.rectanglesIntersect(podA, podB)) {
                    // They intersect, but can the target pod go here?

                    // Check the same size, if not reject.
                    if(value.sizeX !== sizeX || value.sizeY !== sizeY) {
                        valid = false;
                    }

                    // Check it not a locked pod belonging to another user type
                    if(value.locked && (value.xmsType !== $scope.formModel.hiddenUserType)) {
                        valid = false;
                    }
                }
            }
        }

        return valid;
    }

    $scope.resetPositions = function() {
        angular.copy($scope.podPositionCopies, $scope.pods);
    }

    $scope.initPods = function() {

        var anyPodMoved = false;
        var anyPodMoveError = false;

        // Push the static json pods into the service
        $scope.pods.push.apply($scope.pods, $scope.initialPods);

        // X3-3392
        // Determine if there are any overlapping pods, if they belong to the same user, move them
        // and once all possible overlaps are moved then notify the user of the automatic changes
        // and save the updated data
        for (var i = 0; i < $scope.pods.length; i++) {
            var result = podService.checkPodConflicts($scope.pods[i], $scope.formModel.hiddenUserType, $scope.gridsterOpts.maxSizeY);
            if (result != null) {
                if (result) {
                    anyPodMoved = true;
                } else {
                    anyPodMoveError = true;
                }
            }
        }
        if(anyPodMoveError) {
            xmsNotificationFactory.addObj({
                id: "podGrid",
                type: "error",
                bodyHtml: "There are overlapping pods that cannot be moved, please contact your XMS administrator",
                timeout: 30
            });
        }

        if(anyPodMoved) {
            $scope.savePositions();
            xmsNotificationFactory.addObj({
                id: "podGrid",
                type: "warning",
                bodyHtml: "There were overlapping pods in the layout, they have been relocated",
                timeout: 30
            });
        }
    }

    $scope.resetPods = function() {
            ajaxCall.getData($scope.resetPodsUrl, {userType: $scope.formModel.hiddenUserType, layoutId: $scope.formModel.hiddenLayoutId}).then(
                function(result) {
                    $scope.pods.length = 0
                    $scope.pods.push.apply($scope.pods, result.data)
                    xmsNotificationFactory.addObj({id: "podGrid", type: "success", bodyHtml: "Pods reset to organisation defaults", timeout:4});
                },
                function(result) {
                    xmsNotificationFactory.addObj({id: "podGrid", type: "danger", bodyHtml: "Failed to reset to organisation defaults", timeout:10});
                }
            );
    }

    $scope.updatePods = function(updatedPods) {
        for (var i = 0; i < updatedPods.length; i++) {
            angular.extend($scope.pods[i],updatedPods[i]);
        }
    }

    $scope.$on('pod.position.updated', function(event, args) {
        $scope.savePositions();
    });

    $scope.getPodClasses = function(pod) {
        console.log("called get pod classes");
        var classes = '';
        if((!pod.locked) || (pod.locked && pod.xmsType == formModel.hiddenUserType)){
            classes += 'gridster-no-drag';
        }

        return classes;
    }

   /* $scope.checkPodConflicts = function (pod) {
        var result = podService.checkPodConflicts(pod, $scope.formModel.userType);
        if(result !== null) {
            if(result) {
                xmsNotificationFactory.addObj({
                    id: "podGrid",
                    type: "warning",
                    bodyHtml: "There was an overlapping pods in the layout, they have been relocated to row " + pod.row + " column " + pod.col,
                    timeout: 30
                });
            } else {

            }
        }
    }*/

    $scope.savePositions = function () {
        $scope.podsProcessing = true;
        $http.post($scope.savePodPositionUrl,
            {pods: $scope.pods, userType: $scope.formModel.hiddenUserType},
            {headers: {'Content-Type': 'application/json'} } )

            .then(function successCallback(response) {
                $scope.updatePods(response)
                xmsNotificationFactory.addObj({
                    id: "podGrid",
                    type: "success",
                    bodyHtml: "Pod positions saved",
                    timeout: 4 });
                $scope.podsProcessing = false;

            }, function errorCallback(response) {
                xmsNotificationFactory.addObj({
                    id: "podGrid",
                    type: "error",
                    bodyHtml: "Failed to save pod positions",
                    timeout: 10
                });
                $scope.podsProcessing = false;
            });
    }
}
PodGridCtrl.$inject = ['$scope','$http','ajaxCall','xmsNotificationFactory', 'podService'];
angular.module('app').controller('PodGridCtrl',PodGridCtrl);
